<div class="organization-choice-page">
  <header class="organization-choice-page__header container">
    <app-logo
      class="organization-choice-page__logo"
      height="28"
      [name]="logoType.OrganizerDark"
      [alt]="'a11y.fed_landing.logo' | translate"
    ></app-logo>
  </header>

  <main class="container organization-choice-page__container">
    <div class="organization-choice-page__content">
      <h1
        class="organization-choice-page__title"
        aria-label="organization choice"
      >
        {{ 'organizer.organization_choice.title' | translate }}
      </h1>
      <h2
        class="organization-choice-page__description"
        aria-label="organization choice description"
      >
        {{ 'organizer.organization_choice.description' | translate }}
      </h2>
      <ul class="organization-choice-page__list">
        <li
          *ngFor="let organization of organizations[0]?.organizations"
          class="organization-choice-page__list__item cursor-pointer"
          (click)="saveOrganization(organization)"
          onKeyPress
          onKeyDown
          onKeyUp
        >
          <img
            *ngIf="organization?.logo"
            [src]="organization?.logo"
            loading="lazy"
            alt=""
            class="organization-choice-page__list__item__img"
          />
          <span class="organization-choice-page__list__item__name">{{
            organization?.name
          }}</span>
          <vtmn-play-icon
            class="organization-choice-page__list__item__arrow-icon"
            [name]="iconType?.ChevronRight"
          ></vtmn-play-icon>
        </li>
      </ul>
    </div>
  </main>
</div>
